import { LoginSettings } from '@anecdotes/api-contracts';
import { createAction, props } from '@ngrx/store';

export const LoginSettingsActions = {
  Load: createAction('[LoginSettings] load'),
  Loaded: createAction('[LoginSettings] loaded', props<{ loginSettings: LoginSettings }>()),
  ToggleIdp: createAction('[LoginSettings] change idp login', props<{ idpId: string }>()),
  ToggleEmailLogin: createAction('[LoginSettings] change email login', props<{ settingId: string }>()),
  ToggleSupportTeamLogin: createAction('[LoginSettings] change support team login'),
  ChangesSaved: createAction('[LoginSettings] changes saved'),
  SaveChangesFailed: createAction('[LoginSettings] save changes failed'),
};
